module.exports = __webpack_public_path__ + "img/jira.a397460c.svg";